"use client";

import { Navbar, Dropdown, Avatar, Badge } from "flowbite-react";
import { Link } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { Button } from "antd";
import EventEmitter from "../utils/eventEmitter";





const Header = () => {

  const openLockDate = () => EventEmitter.dispatch('open_lock_date', true);
  return (
    <Navbar fluid rounded className="mb-3 border-b-2 header">
      <div className="flex">
        <Link className="me-3 p-2 border-2 rounded hover:text-blue-500" to={'/'}>{<MdDashboard />}</Link>
        <Navbar.Brand as={Link} to={'/accounting/'} className="w-50">
          <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">Accounting</span>
        </Navbar.Brand>
      </div>
      <div className="flex">
        <Dropdown arrowIcon={false} inline label={<span className="mx-2 z-30">Accounting</span>}>
          <Badge className="text-slate-600 bg-transparent	">Miscellaneous</Badge>
          <Dropdown.Item as={Link} to={'/accounting/journal-entries/new'}>Journal Entries</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/journal-items'}>Journal Items</Dropdown.Item>
          <Badge className="text-slate-600 bg-transparent	">Journals</Badge>
          <Dropdown.Item as={Link} to='/accounting/journal-items/sales'>Sales</Dropdown.Item>
          <Dropdown.Item as={Link} to='/accounting/journal-items/purchases'>Purchases</Dropdown.Item>
          <Dropdown.Item as={Link} to='/accounting/journal-items/bank'>Bank and Cash</Dropdown.Item>
          <Dropdown.Item as={Link} to='/accounting/journal-items/miscellaneous'>Miscellaneous</Dropdown.Item>
          {/* <Dropdown.Divider /> */}
          <Badge className="text-slate-600 bg-transparent	">Managements</Badge>
          <Dropdown.Item as={Link} to={'/accounting/budgets'}>Budgets</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/assets'}>Assets</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/deferred-revenues'}>Deferred Revenue</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/deferred-expenses'}>Deferred Expense</Dropdown.Item>
          <Badge className="text-slate-600 bg-transparent	">Actions</Badge>
          <Dropdown.Item>Reconciliation</Dropdown.Item>
          <Dropdown.Item onClick={openLockDate}>Lock Dates</Dropdown.Item>
        </Dropdown>
        <Dropdown arrowIcon={false} inline label={<span className="mx-2 z-30">Customers</span>}>
          <Dropdown.Item as={Link} to={'/accounting/invoices'}>Invoices</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/credit-notes'}>Credit Notes</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/customer/payments'} state={{is_customer: true}}>Payments</Dropdown.Item>
        </Dropdown>
        <Dropdown arrowIcon={false} inline label={<span className="mx-2 z-30">Vendor</span>}>
          <Dropdown.Item as={Link} to={'/accounting/bills'}>Bills</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/debit-notes'}>Debit Notes</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/vendor/payments'} state={{is_customer: false}}>Payments</Dropdown.Item>
        </Dropdown>
        <Dropdown arrowIcon={false} inline label={<span className="mx-2 z-30">Configurations</span>}>
          <Dropdown.Item as={Link} to={'/accounting/settings'}>Settings</Dropdown.Item>
          <Badge className="text-slate-600 bg-transparent	">Accounting</Badge>
          <Dropdown.Item as={Link} to={'/accounting/accounts'}>Charts of Accounts</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/journals'}>Journals</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/taxes'}>Taxes</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/tags'}>Tags</Dropdown.Item>
          <Badge className="text-slate-600 bg-transparent	">Managements</Badge>
          <Dropdown.Item as={Link} to={'/accounting/budgetary-positions'}>Budgetary Positions</Dropdown.Item>
          <Badge className="text-slate-600 bg-transparent	">Analytic Accounting</Badge>
          <Dropdown.Item as={Link} to={'/accounting/analytic-accounts'}>Analytic Accounts</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/analytic-items'}>Analytic Items</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/analytic-plans'}>Analytic Plans</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/analytic-distribution-models'}>Analytic Distribution Models</Dropdown.Item>

        </Dropdown>
        <Dropdown arrowIcon={false} inline label={<span className="mx-2 z-30">Reports</span>}>
          <Badge className="text-slate-600 bg-transparent	">Financial Reports</Badge>
          <Dropdown.Item as={Link} to={'/accounting/report/balance-sheet'}>Balance Sheets</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/report/income-statement'}>Income Statement</Dropdown.Item>

          <Badge className="text-slate-600 bg-transparent	">Partner Reports</Badge>
          <Dropdown.Item as={Link} to={'/accounting/report/partner-ledger'}>Partner Ledger</Dropdown.Item>

          <Badge className="text-slate-600 bg-transparent	">Auditing</Badge>
          <Dropdown.Item as={Link} to={'/accounting/tax-report'}>Tax Report</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/journal-report'}>Journal Report</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/general-ledger-report'}>General Ledger Report</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/accounting/trial-balance'}>Trial Balance</Dropdown.Item>
        </Dropdown>
      </div>
      <div className="">
        
        <Dropdown
          arrowIcon={false}
          inline
          label={
            <Avatar alt="User settings" img="https://flowbite.com/docs/images/people/profile-picture-5.jpg" rounded />
          }
        >
          <Dropdown.Header>
            <span className="block text-sm">Bonnie Green</span>
            <span className="block truncate text-sm font-medium">name@flowbite.com</span>
          </Dropdown.Header>
          <Dropdown.Item>Dashboard</Dropdown.Item>
          <Dropdown.Item>Settings</Dropdown.Item>
          <Dropdown.Item>Earnings</Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item>Sign out</Dropdown.Item>
        </Dropdown>
        {/* <Navbar.Toggle /> */}
      </div>
      {/* <Navbar.Collapse>
        <Navbar.Link href="#" active>
          Home
        </Navbar.Link>
        <Navbar.Link href="#">About</Navbar.Link>
        <Navbar.Link href="#">Services</Navbar.Link>
        <Navbar.Link href="#">Pricing</Navbar.Link>
        <Navbar.Link href="#">Contact</Navbar.Link>
      </Navbar.Collapse> */}
    </Navbar>
  );
}




export default Header;